__turbopack_context__.v({
  "button": "VTm53q_button",
  "container": "VTm53q_container",
  "description": "VTm53q_description",
  "people": "VTm53q_people",
});
